const CONSTANTS = {
  ON_APP_LOADING: "app/ON_APP_LOADING",
  CAMPAIGN: "app/CAMPAIGN",
};

export { CONSTANTS };
